// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"166":"ca3485c3","284":"391c98dc","355":"4c07166e","618":"6f107841","734":"74726613","916":"c0cf6f6e"}[chunkId] + ".css";
};